
$(function () {

  // rest of the script
  const moment = require('moment-timezone');
  const timeZoneName = moment.tz.guess();
  const language = $('html')[0].lang;
  const myProject = require('./_data/myProject');
  const envSettings = myProject[myProject.environment];
  const scripts = document.getElementsByTagName('script');
  const thisScript = scripts[scripts.length - 1]; // assuming the current script is the last one on the page
  const queryString = thisScript.src.replace(/^[^\?]+\??/, ''); // extract query string from script URL
  const urlParams = new URLSearchParams(queryString);
  const languages = document.getElementById("reviewJsScript").src.split("language=")[1]

  //reviewJsScript
  // defaults
  $.ajaxSetup({
    headers: { "X-TimeZoneName": timeZoneName, "X-Language": language },
    contentType: "application/json; charset=utf-8",
    dataType: "json"
  });
  // Ottaa tiedot generatedLanguges, vaihda POST muotoon ja ota tiedot raja pinnasta
  const Uris = {
    jsonReviews: envSettings.server + "/json/newsitems/list?displayLocation=YOUPRET"
  };
  // GET
  $.ajax({
    url: Uris.jsonReviews,
    type: "GET",
    success: function (data) {
      console.log(data)
      var filteredData = [];
      data.map((item) => {
        console.log(item);
        console.log(languages);
        if(item.displayLanguages.includes(languages) && item.isReview) {
          filteredData.push(item);
        }
      });
      console.log(filteredData);
      var results = $.map(filteredData, function (item) {
        return {
          id: item.id,
          title: item.title,
          rating: item.rating,
          contentText: item.shortContent,
          publishDate: item.publishDate,
        };
      });

      var reviewsContainer = $('#reviews-container');
      
      
      $.each(results, function (index, result) {
        if (index < 3) {
          // nimi
          var reviewTitle = $('<h5>').text(result.title);
          // tähdet
          var reviewRating = $('<div>').addClass('review-rating');
          var numStars = result.rating;
          for (var i = 0; i < numStars; i++) {
            var star = $('<div>').addClass('StarImage').attr('alt', 'star');
            reviewRating.append(star);
          }
          // arvostelu teksti


          var reviewText = $('<div>').addClass('review-text').text(result.contentText);
          if (result.contentText.length > 100) {
            reviewText.text(result.contentText.substring(0, 100) + '...');
          }
          // lue lisää
          var readMoreButton = $('<a>').text('Lue lisää').addClass('read-more-button');
          readMoreButton.data('review-data', result);
          readMoreButton.on('click', function () {
            var existingModal = $('#review-modal');
            if (existingModal.length > 0) {
              existingModal.remove();
            }
            var reviewData = $(this).data('review-data');
            var modalBody = $('<div>').addClass('modal-body');
            var modalTitle = $('<h5>').addClass('modal-title mb-3').text(reviewData.title);
            var modalStars = $('<div>').addClass('modal-stars mb-3');
            var formattedDate = moment(reviewData.publishDate).format('DD.MM.YYYY');
            var modalPublish = $('<div>').addClass('modal-publish mb-3').text("Arvioitu " + formattedDate);

            var numModalStars = reviewData.rating;
            for (var i = 0; i < numModalStars; i++) {
              var star = $('<div>').addClass('StarImage').attr('alt', 'star');
              modalStars.append(star);
            }
            
            modalBody.append(modalTitle, modalPublish, modalStars, reviewData.contentText);

            var modal = $('<div>').addClass('modal fade').attr('id', 'review-modal').append(
              $('<div>').addClass('modal-dialog modal-dialog-centered').append(
                $('<div>').addClass('modal-content').append(
                  modalBody
                )
              )
            );
            $('body').append(modal);
            $('#review-modal').modal('show');
          });

          // kootaan kaikki yhteen
          var review = $('<div>').addClass('review').append(reviewTitle, reviewRating, reviewText, readMoreButton);
          reviewsContainer.append(review);
        } else {

          return false;
        }
      });

      console.log(results);
    },

    error: function (jqXHR, textStatus, errorThrown) {
      console.error("Error loading JSON file: " + errorThrown);
    }
  });
  
});